import { useReport } from './hooks/use-context';
import type { QuestionData } from './types';

export const Pictures = () => {
  const { body, values } = useReport();
  const picturesAnswers: Array<{ url: string; caption?: string }> = [];

  // Iterate over all sections and questions to extract pictures
  body?.sections?.forEach((section) => {
    section.questions?.forEach((question: QuestionData) => {
      // Direct pictures Answers
      question.answers?.forEach((answer) => {
        if (answer.attachment && Array.isArray(answer.attachment)) {
          answer.attachment.forEach((att) => {
            if (att.url) {
              picturesAnswers.push({
                url: att.url,
                caption: att.caption || question.name,
              });
            }
          });
        }
      });
    });
  });

  // Extract from Others section specifically (Registro Fotográfico)
  if (values?.registro_fotografico?.answers) {
    values.registro_fotografico.answers.forEach((answer) => {
      if (answer.attachment && Array.isArray(answer.attachment)) {
        answer.attachment.forEach((att) => {
          if (att.url) {
            picturesAnswers.push({
              url: att.url,
              caption: att.caption || values.registro_fotografico?.name,
            });
          }
        });
      }
    });
  }

  if (picturesAnswers.length === 0) return null;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginTop: '1rem',
      }}
    >
      <div
        style={{
          backgroundColor: '#d1d5db',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0.25rem',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: '#000',
          fontWeight: 700,
          textTransform: 'uppercase',
          fontSize: '0.875rem',
          lineHeight: '1.25rem',
          marginBottom: '1rem',
        }}
      >
        Registro Fotográfico
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gap: '1rem',
        }}
      >
        {picturesAnswers.map((pic, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index} style={{ display: 'flex', flexDirection: 'column' }}>
            <div
              style={{
                width: '100%',
                height: '16rem',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: '#000',
                padding: '0.25rem',
              }}
            >
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src={pic.url}
                alt="attachment"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                }}
              />
            </div>
            {pic.caption && (
              <p
                style={{
                  fontSize: '0.75rem',
                  lineHeight: '1rem',
                  textAlign: 'center',
                  marginTop: '0.5rem',
                  fontWeight: 500,
                }}
              >
                {pic.caption}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
